import { Grid, Box, Typography } from "@mui/material";
import "../Styles/AdminListings.css";
import { useSelector } from "react-redux";

function ActiveCounts(props) {

    const { numberofActiveUsers, numberofCareFaclities } = useSelector(state => state.activeCounts)
    return(
        <Box>
            <Grid xs={12} >
                <Grid item xs={10} >
                    <Box alignItems="center" display="flex" float="left" height="20px" width="100%" columnGap="1rem" gap="1rem">
                        
                        <Typography><span style={{fontWeight:"bold", marginRight:"3px"}}>Active Care Facility:</span>{ numberofCareFaclities }</Typography>
						<Typography><span style={{fontWeight:"bold", marginRight:"3px"}}>Active Client Users:</span>{ numberofActiveUsers }</Typography>
                        {props.showNote ?<Typography><span style={{marginRight:"3px"}}></span>
                        <p style={{fontSize:"13px", fontWeight: 10, color: "grey", marginBottom:"25px", fontFamily:'sans-serif'}}><strong>(Note: </strong> 
                        The newly enrolled client user status gets updated daily at the end of business day.)</p>
                        </Typography>: ""}
                              
                    </Box>
                </Grid>
                <Grid item xs={2} ></Grid>
            </Grid>
        </Box>
    )

}

export default ActiveCounts;